import type { Tab } from '@/components/insights/types/tabs';
import { Tab as TabEnum } from '@/components/insights/types/tabs';
import { OriginView, type OriginViewValueType } from '../Avo';

export const getOriginView = (currentTab: Tab): OriginViewValueType => {
  switch (currentTab) {
    case TabEnum.Deliverables:
      return OriginView.DELIVERABLES;
    case TabEnum.Progress:
      return OriginView.PROGRESS;
    case TabEnum.InvestmentBalance:
      return OriginView.INVESTMENT_BALANCE;
    default:
      return OriginView.PROGRESS;
  }
};
